/** Палітра кольорів значень полів вибору (прототип v4 PAL): 12 тонів від червоного до сланцевого. */
export const VALUE_PALETTE: readonly string[] = ['#b91c1c', '#ef4444', '#f97316', '#eab308', '#84cc16', '#16a34a', '#14b8a6', '#0ea5e9', '#2563eb', '#7c3aed', '#db2777', '#64748b'];
